<template>
  <div class="mobile-margin">
    <div class="content">
      <div class="columns">
        <aside class="column is-4 aside-contact-list is-paddingless">
          <div class="card card-user">
            <div
              class="accordion-title"
              :class="{'active': isActive}"
              @click="isActive = !isActive"
            >
              Messenger
            </div>
            <div
              v-if="isActive && friends"
              class="card-content"
            >
              <div class="contact-list">
                <div class="search-desktop">
                  <span class="icon is-right">
                    <i class="far fa-search" />
                  </span>
                  <input
                    v-model="search"
                    placeholder="Start typing a friend's name"
                    class="input-search"
                    type="text"
                  >
                </div>
              </div>
              <div
                v-for="(friend, index) in filteredFriends"
                class="contact-list"
              >
                <div
                  class="is-flex"
                  style="cursor: pointer"
                  @click.stop.prevent="getMessages(friend.ahlid, index)"
                >
                  <img
                    v-if="!friend.memberphoto"
                    class="img-circle mr-4"
                    src="/images/profile.png"
                  >
                  <img
                    v-if="friend.memberphoto"
                    class="img-circle mr-4"
                    :src="friend.memberphoto"
                  >
                  <strong
                    class="is-size-7"
                    :class="{badge: countUnreadMessages(index)}"
                    :data-badge="countUnreadMessages(index)"
                    style="cursor: pointer"
                  >{{ friend.name }}</strong>
                </div>
              </div>
            </div>
          </div>
        </aside>
        <div class="column is-8">
          <div
            id="messages"
            ref="messages"
            class="block-message"
          >
            <div
              v-if="!loaded"
              class="is-flex justify-content-center block-loader"
            >
              <sync-loader />
              <p>Loading ...</p>
            </div>
            <div
              v-if="!selectedFriend && loaded"
              class="is-flex has-text-centered"
            >
              <div class="no-messages">
                <i class="far fa-comments" /><br>
                <span>Select a friend</span>
              </div>
            </div>
            <div
              v-if="selectedFriend && messages.length === 0 && loaded"
              class="is-flex has-text-centered"
            >
              <div class="no-messages">
                <i class="far fa-comments" /><br>
                <span>There are no any messages yet.</span>
              </div>
            </div>
            <div v-if="loaded">
              <div
                v-for="message in messages"
                class="wrapper-message"
              >
                <div class="is-size-7 has-text-centered message-date">
                  {{ message.sentdate.split(' ')[0] }}
                </div>
                <div
                  v-if="message.sentfrom !== user.ahlid"
                  class="is-flex is-fullwidth opacity-hover left-message"
                >
                  <img
                    v-if="!selectedFriend.memberphoto"
                    class="img-circle"
                    src="/images/profile.png"
                  >
                  <img
                    v-if="selectedFriend.memberphoto"
                    class="img-circle"
                    :src="selectedFriend.memberphoto"
                  >
                  <div class="message">
                    <span>{{ message.message }}</span>
                  </div>
                  <a
                    class="delete"
                    @click="deleteMessage(message.id)"
                  />
                </div>
                <div
                  v-if="message.sentfrom === user.ahlid"
                  class="is-flex is-fullwidth opacity-hover right-message"
                >
                  <img
                    v-if="!user.memberphoto"
                    class="img-circle"
                    src="/images/profile.png"
                  >
                  <img
                    v-if="user.memberphoto"
                    class="img-circle"
                    :src="user.memberphoto"
                  >
                  <div class="message">
                    <span>{{ message.message }}</span>
                  </div>
                  <a
                    class="delete"
                    @click="deleteMessage(message.id)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <p class="control">
              <textarea
                v-if="selectedFriend"
                v-model="message"
                class="textarea"
                :placeholder="`New message to ${selectedFriend.name}`"
              />
              <textarea
                v-if="!selectedFriend"
                v-model="message"
                class="textarea"
                placeholder="Select a friend!"
              />
            </p>
            <div
              class="control post-comment-btn"
              style="position: relative;"
            >
              <a
                class="button is-info is-block"
                @click="sendMessage()"
              >
                <span class="icon">
                  <i
                    class="far fa-paper-plane"
                    aria-hidden="true"
                  />
                </span>
                <span>Send</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'MyMessages',
    metaInfo: {
      title: 'AHL Poker :: My Messages'
    },
    components: {
    },
    props: ['user', 'token', 'friends'],
    data() {
      return {
        isActive: false,
        selectedFriend: '',
        message: '',
        messages: '',
        search: '',
        loaded: true,
        sending: false
      }
    },
    computed: {
      filteredFriends() {
        return this.friends.filter(f => f.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
      }
    },
    mounted() {
      if (!this.user) {
        this.$router.push('/')
      }
      if (window.innerWidth > 1023) {
        this.isActive = true
      }
    },
    methods: {
      getMessages(id, index) {
        this.loaded = false
        this.selectedFriend = this.friends[index]
        this.$axios({
          method: 'POST',
          url: `member/messages/get/${id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token
          }
        })
          .then((res) => {
            this.messages = res.data
            this.loaded = true
            let timeout = setTimeout(() => {
              this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
              clearTimeout(timeout)
            }, 50)
            this.$emit('updateMessagesCount')
          })
          .catch((error) => {
            this.$emit('message', {error: true, message: error.response.data.message})
          })
      },
      sendMessage() {
        if (!this.selectedFriend || !this.message) return
        this.sending = true
        this.$axios({
          method: 'POST',
          url: `member/messages/send`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token,
            to: this.selectedFriend.ahlid,
            message: this.message
          }
        })
          .then((res) => {
            let index = this.friends.findIndex(f => f.ahlid === this.selectedFriend.ahlid)
            this.getMessages(this.selectedFriend.ahlid, index)
            this.message = ''
            this.$emit('message',
              {
                error: false,
                message: res.data.message
              })
            this.sending = false
            let timeout = setTimeout(() => {
              this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
              clearTimeout(timeout)
            }, 50)
          })
          .catch((error) => {
            console.log(error)
          })
      },
      deleteMessage(id) {
        this.$axios({
          method: 'POST',
          url: `member/messages/delete/${id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token
          }
        })
          .then((res) => {
            let index = this.friends.findIndex(f => f.ahlid === this.selectedFriend.ahlid)
            this.getMessages(this.selectedFriend.ahlid, index)
            this.$emit('message',
              {
                error: false,
                message: 'The message has been deleted'
              })
            let timeout = setTimeout(() => {
              this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
              clearTimeout(timeout)
            }, 50)
          })
          .catch((error) => {
            console.log(error)
          })
      },
      formatDate(timestamp) {
        let monthNames = [
          'Jan', 'Feb', 'Mar',
          'Apr', 'May', 'Jun', 'Jul',
          'Aug', 'Sep', 'Oct',
          'Nov', 'Dec'
        ]
        let date = new Date(timestamp)
        let day = date.getDate()
        let monthIndex = date.getMonth()
        let year = date.getFullYear()

        return day + ' ' + monthNames[monthIndex] + ' ' + year
      },
      selectFriend(id) {
        this.$axios({
          method: 'POST',
          url: `member/messages/read/${id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token
          }
        })
          .then(() => {
//            this.selectedFriend.message[i].unread = 0
//            this.$emit('updateMessages')
          })
      },
      countUnreadMessages(index) {
        return this.friends[index].unread
      }
    }
  }
</script>
